import { useQuery } from "@tanstack/react-query";

import { useTRPC } from "@/trpc";

// Each section should display its result without waiting for slower history queries.
const independentQueryOptions = {
  trpc: { context: { skipBatch: true } },
};

export const useAdminUserData = (userId: string) => {
  const trpc = useTRPC();

  const userQuery = useQuery(
    trpc.adminDashboard.getUserById.queryOptions(
      { userId },
      independentQueryOptions,
    ),
  );

  const communicationsQuery = useQuery(
    trpc.adminDashboard.getUserCommunications.queryOptions(
      { userId },
      independentQueryOptions,
    ),
  );

  const interestedJobPostsQuery = useQuery(
    trpc.adminDashboard.getUserInterestedJobPosts.queryOptions(
      { userId },
      independentQueryOptions,
    ),
  );

  const recommendedJobPostsQuery = useQuery(
    trpc.adminDashboard.getUserRecommendedJobPosts.queryOptions(
      { userId },
      independentQueryOptions,
    ),
  );

  return {
    userQuery,
    communicationsQuery,
    interestedJobPostsQuery,
    recommendedJobPostsQuery,
  };
};
